import React from "react";
import ContentSidebar from "./contentSidebar";
import Activity from "./Activity";

const SideContent = () => {
    return <div style={{width: 300}}>
        {/* <ContentSidebar /> */}
        {/* <Activity /> */}
    </div>
};

export default SideContent;